import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material'
import React from 'react'
import Location from "../../assets/Location.png";
import Phone from "../../assets/Phone.png";
import Social1 from "../../assets/Social1.png";
import Social2 from "../../assets/Social2.png";
import Social3 from "../../assets/Social3.png";
import Social10 from "../../assets/Social10.png";
import Social9 from "../../assets/Social9.png";
import Social8 from "../../assets/Social8.png";
import { useSelector } from 'react-redux'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link, useNavigate } from 'react-router-dom';

function HelpCenter() {
    
    const styles = useSelector((state) => state.styles)
    const language = useSelector((state) => state.language.language)
    const data = useSelector((state) => state.AdminData.admin);
    console.log(data, 'abc')
    const navigate = useNavigate()

    const images = [
        {
        id : 1, 
        image : Social3,
        onClick: () => {
            window.open("https://www.facebook.com/SingaporeCustodianServices", "_blank");
          },
        },
        {
        id : 2, 
            image : Social8,
            onClick: () => {
                window.open(
                  "https://www.instagram.com/vinga_sg/",
                  "_blank"
                );
              },
            },
            {
                id : 3, 
                image : Social9,
                onClick: () => {
                    window.open(
                      "https://www.xiaohongshu.com/user/profile/6202f9f0000000001000f392",
                      "_blank"
                    );
                  },
                },
                {
                    id : 4, 
                    image : Social10,
                    onClick: () => {
                        window.open("https://www.tiktok.com/@singaporedr2023?_t=8lLSmptEkuP&_r=1", "_blank");
                      },
                    },
                    {
                        id : 5, 
                        image : Social3,
                        onClick: () => {
                            window.open("https://www.facebook.com/SingaporeVingaInternationalStudentHostel/", "_blank");
                          },
                        },
                        // {
                        //     id : 6, 
                        //     image : Social6
                        //     },

]

const faq = [
    {
        id : 1,
        question : {
            'en' : 'Booking & Reservations related issue',
            'zh-tw' : 'Booking & Reservations related issue',
            'zh' : 'Booking & Reservations related issue'
        },
        answer : {
            'en' : 'Booking & Reservations related issue',
            'zh-tw' : 'Booking & Reservations related issue',
            'zh' : 'Booking & Reservations related issue'
        }
    },
    {
        id : 2,
        question : {
            'en' : 'Booking & Reservations related issue',
            'zh-tw' : 'Booking & Reservations related issue',
            'zh' : 'Booking & Reservations related issue'
        },
        answer : {
            'en' : 'Booking & Reservations related issue',
            'zh-tw' : 'Booking & Reservations related issue',
            'zh' : 'Booking & Reservations related issue'
        }
    },
    {
        id : 2,
        question : {
            'en' : 'Booking & Reservations related issue',
            'zh-tw' : 'Booking & Reservations related issue',
            'zh' : 'Booking & Reservations related issue'
        },
        answer : {
            'en' : 'Booking & Reservations related issue',
            'zh-tw' : 'Booking & Reservations related issue',
            'zh' : 'Booking & Reservations related issue'
        }
    },
    {
        id : 2,
        question : {
            'en' : 'Booking & Reservations related issue',
            'zh-tw' : 'Booking & Reservations related issue',
            'zh' : 'Booking & Reservations related issue'
        },
        answer : {
            'en' : 'Booking & Reservations related issue',
            'zh-tw' : 'Booking & Reservations related issue',
            'zh' : 'Booking & Reservations related issue'
        }
    }
]

const links = [
    {
        id : 1,
        title : 'Login',
        navigateTo : '/login'
    },
    // {
    //     id : 2,
    //     title : 'Register',
    //     navigateTo : '/login'
    // },
    // {
    //     id : 3,
    //     title : 'Forgot Password',
    //     navigateTo : '/login'
    // }
]

  return (
    <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', mt : '60px', flexDirection : 'column'}}>
        <Box>
            <Typography sx={{...styles.h3, color : '#434343', textAlign : 'center'}}>Help Center</Typography>
            <Typography sx={{color : '#434343', fontSize : '18px', mt : '8px'}}>Find quick answers or reach out to us directly</Typography>
        </Box>
        <Box sx={{mt : '64px'}}>
            <Typography sx={{fontSize : '24px', fontWeight : 700, color : '#434343', textAlign : 'center'}}>Hostel Details</Typography>
            <Box sx={{mt : '24px', display : 'flex', gap : '46px', alignItems : 'center'}}>
                <Box>
                    <Typography sx={{textAlign : 'center', fontWeight : 700, color : '#434343'}}>VingaHall @ RG</Typography>
                    
                    <Box sx={{display : 'flex', gap : '10px', mt : '20px', alignItems :'start', flexDirection : 'column', justifyContent : 'start'}}>
                    <Box sx={{display : 'flex', gap : '10px', alignItems :'center'}}>
                    <Box component={'img'} src={Phone} sx={{width : '24px'}}/>
                    <Typography>+65 6962 6868 / +65 6677 6789</Typography>
                    </Box>
                    
                    <Box sx={{display : 'flex', gap : '10px', alignItems :'center'}}>
                    <Box component={'img'} src={Location} sx={{width : '24px'}}/>
                    <Typography>No.99 Rangoon Road Singapore 218384</Typography>
                    </Box>
                    </Box>
                </Box>

                <Box>
                    <Typography sx={{textAlign : 'center', fontWeight : 700, color : '#434343'}}>VingaHall @ BK</Typography>
                    
                    <Box sx={{display : 'flex', gap : '10px', mt : '20px', alignItems :'start', flexDirection : 'column', justifyContent : 'start'}}>
                    <Box sx={{display : 'flex', gap : '10px', alignItems :'center'}}>
                    <Box component={'img'} src={Phone} sx={{width : '24px'}}/>
                    <Typography>+65 6962 6868 / +65 6677 6789</Typography>
                    </Box>
                    
                    <Box sx={{display : 'flex', gap : '10px', alignItems :'center'}}>
                    <Box component={'img'} src={Location} sx={{width : '24px'}}/>
                    <Typography>10/12 Beng Wan Road, Singapore 339842</Typography>
                    </Box>
                    </Box>
                </Box>
            </Box>

            <Box sx={{mt : '60px'}}>
                <Typography sx={{fontSize : '24px', fontWeight : 700, color : '#434343', textAlign : 'center'}}>Social Media</Typography>
                <Box sx={{mt : '24px', display : 'flex', alignItems : 'center', gap : '40px',  justifyContent :'center'}}>
                        {images.map((image) => (
                            <Box onClick={() => image.onClick()} key={image.id} sx={{":hover" : {cursor : 'pointer'} ,display : 'flex', justifyContent : 'center', alignItems :'center',border : '1px solid #27BAC4', width : '44px', height : '44px', gap : '10px', borderRadius : '10px'}}>
                                <Box component={'img'} src={image.image} sx={{width : '24px'}}/>
                            </Box>
                        ))}
                </Box>
            </Box>

            <Box sx={{mt : '60px'}}>
            <Typography sx={{fontSize : '24px', fontWeight : 700, color : '#434343', textAlign : 'center'}}>FAQ Support</Typography>
            <Box sx={{mt : '24px'}}>
                <Box sx={{p : '24px', border: "1px solid #E0E0E0", borderTopLeftRadius : '10px', borderTopRightRadius : '10px'}}>
                    <Typography sx={{fontSize : '18px', color : '#434343'}}>What issue are you facing?</Typography>
                </Box>
                {faq.map((item) => (
                        <Accordion key={item.id}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography sx={{color : '#434343', fontWeight : 400}}>{item.question[language]}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography sx={{color : '#434343', fontWeight : 400}}>{item.answer[language]}</Typography>
                        </AccordionDetails>
                        </Accordion>
                    ))}
            </Box>
            </Box>

            <Box sx={{mt : '40px', borderRadius : '10px', border: "0.5px solid #E0E0E0", p : '12px 24px', display : 'flex', justifyContent : 'center',alignItems : 'center', gap : '40px'}}>
                    <Typography sx={{fontSize : '18px', fontWeight : 700}}>Still need help? Reach our support team?</Typography>
                    <Button onClick={() => navigate("/contact-us")} variant='contained' sx={{...styles.button, width : '200px', borderRadius : '10px'}}>Contact Us</Button>
            </Box>
            
            {!data?.userName && (
                <Box sx={{mt : '20px', display : 'flex', justifyContent : 'center', alignItems : 'center', gap : '24px'}}>
                    {links.map((link) => (
                        <Link style={{ textDecoration: 'underline', color: 'blue' }} to={link.navigateTo}>{link.title}</Link>
                    ))}
            </Box>
            )}
            

            <Box sx={{mt : '60px'}}>

            </Box>
        </Box>
    </Box>
  )
}

export default HelpCenter